const pdfMake = require('pdfmake/build/pdfmake.js');
const pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default function transferPdfMaker(row, transfer, getMember, owners, getCompanyInfo) {
  const rowsTop: any[] = [];
  const rows: any[] = [];
  const p = 'Transfer of ' + transfer.value + ' share(s) on ' + row.date;
  const title = 'Transfer from ' + row.from + ' to ' + row.to;
  const initial =
    'initial balance of sender: ' +
    transfer.senderbalance +
    ', after: ' +
    (transfer.senderbalance - transfer.value);
  const initial2 =
    'initial balance of receiver: ' +
    transfer.receiverbalance +
    ', after: ' +
    (+transfer.receiverbalance + +transfer.value);
  const signRow = [
    {},
    { text: '\nThe sender: ' + row.from, alignment: 'right' },
    { text: '\n', alignment: 'right' },
    { text: '\nSignature: ' + row.from, alignment: 'right', italics: true }
  ];
  if (transfer.from !== getCompanyInfo.wallet) {
    rowsTop.push(signRow);
  }
  const sign2Row = [
    {},
    { text: '\nThe receiver: ' + row.to, alignment: 'right' },
    { text: '\n', alignment: 'left' },
    { text: '\nSignature: ' + row.to, alignment: 'right', italics: true }
  ];
  if (transfer.to !== getCompanyInfo.wallet) {
    rowsTop.push(sign2Row);
  }
  function ownerSign(name) {
    return { text: '\nSignature: ' + name, alignment: 'right', italics: true };
  }
  for (let addr in owners) {
    const sign3Row = [
      {},
      { text: '\nDirector: ' + getMember(addr).name, alignment: 'right' },
      { text: '', alignment: 'left' },
      ownerSign(getMember(addr).name)
    ];
    rows.push(sign3Row);
  }
  const dd = {
    content: [
      {
        text: title,
        style: 'header',
        margin: [0, 0, 0, 5],
        fontSize: 22
      },
      {
        text: p,
        style: 'header',
        bold: false,
        margin: [0, 0, 0, 5]
      },
      {
        text: initial,
        style: 'header',
        bold: false
      },
      {
        text: initial2,
        style: 'header',
        bold: false,
        margin: [0, 0, 0, 45]
      },
      {
        table: {
          widths: ['*', 'auto', '20%', 'auto'],
          body: rowsTop,
          headerRows: 0
        },
        layout: 'noBorders',
        style: 'header',
        bold: false,
        margin: [0, 0, 0, 150]
      },
      {
        table: {
          widths: ['*', 'auto', '20%', 'auto'],
          body: rows,
          headerRows: 0
        },
        layout: 'noBorders',
        style: 'header',
        bold: false
      }
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        alignment: 'justify'
      }
    }
  };
  return pdfMake.createPdf(dd);
}
